import initPodBuildOrder from "components/pod/pod-build-order/pod-build-order";

document.addEventListener("DOMContentLoaded", initPodBuildOrder);
